<template>
    <div class="meta-referrals">
        <div class="content">
            <div class="referrals">
                <div v-if="contact.metaReferrals.length === 0" class="no-referrals">
                    <i class="fas fa-info-circle"></i>
                    <p>{{ $t("message.noMetaReferrals") }}</p>
                </div>
                <div v-else>
                    <div class="referrals-item" v-for="ad of contact.metaReferrals" :key="ad._id">
                        <div class="headline">
                            <a :href="ad.sourceLink" target="_blank" class="title" v-if="ad.sourceLink">{{ ad.headline || 'Meta Reklam' }}</a>
                            <span class="title" v-else>{{ ad.headline || 'Meta Reklam' }}</span>
                            <div class="time">{{ $moment(ad.createdAt).fromNow() }}</div>
                        </div>
                        <div class="description" v-if="ad.headline || ad.body">{{ ad.body || ad.headline }}</div>
                        
                        <div v-if="ad.adInfo" class="referral-info-wrapper">
                            <div class="referral-info">
                                <div class="referral-detail">
                                    <div class="referral-label">Reklam</div>
                                    <div class="referral-value" :title="ad.adInfo.name || '-'">{{ ad.adInfo.name || '-' }}</div>
                                </div>
                                
                                <div class="referral-detail">
                                    <div class="referral-label">Reklam Seti</div>
                                    <div class="referral-value" :title="getAdSetName(ad)">{{ getAdSetName(ad) }}</div>
                                </div>
                                
                                <div class="referral-detail">
                                    <div class="referral-label">Kampanya</div>
                                    <div class="referral-value" :title="getCampaignName(ad)">{{ getCampaignName(ad) }}</div>
                                </div>
                                
                                <div class="referral-detail">
                                    <div class="referral-label">Durum</div>
                                    <div class="referral-value status" :class="getStatusClass(ad)" :title="getStatus(ad)">{{ getStatus(ad) }}</div>
                                </div>
                            </div>
                        </div>
                        
                        <div v-if="ad.sourceLink" class="referral-link">
                            <a :href="ad.sourceLink" target="_blank">
                                <i class="fas fa-external-link-alt"></i> Reklamı Görüntüle
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "MetaReferrals",
    components: {},
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({}),
    methods: {
        getAdSetName(ad) {
            return this.$_.get(ad, 'adInfo.adset.name', '-');
        },
        getCampaignName(ad) {
            return this.$_.get(ad, 'adInfo.campaign.name', '-');
        },
        getStatus(ad) {
            const effectiveStatus = this.$_.get(ad, 'adInfo.effective_status');
            if (effectiveStatus === 'ACTIVE') return 'Aktif';
            if (effectiveStatus === 'CAMPAIGN_PAUSED') return 'Kampanya Duraklatıldı';
            if (effectiveStatus === 'PAUSED') return 'Duraklatıldı';
            if (effectiveStatus === 'ARCHIVED') return 'Arşivlenmiş';
            return effectiveStatus || '-';
        },
        getStatusClass(ad) {
            const effectiveStatus = this.$_.get(ad, 'adInfo.effective_status');
            if (effectiveStatus === 'ACTIVE') return 'active';
            if (effectiveStatus === 'CAMPAIGN_PAUSED' || effectiveStatus === 'PAUSED') return 'paused';
            if (effectiveStatus === 'ARCHIVED') return 'archived';
            return 'unknown';
        }
    },
};
</script>
<style lang="scss" scoped>
.meta-referrals {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    font-family: "Poppins", sans-serif;

    .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: column;
    }

    .content {
        .referrals {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .no-referrals {
                font-size: 14px;
                color: #999;
                text-align: center;
                padding: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #fafafa;
                border-radius: 8px;

                i {
                    font-size: 28px;
                    margin-bottom: 10px;
                    color: #674ea7;
                }

                p {
                    margin: 0;
                }
            }

            &-item {
                border: 1px solid #e0dbf0;
                padding: 14px;
                border-radius: 8px;
                border-left: 5px solid #674ea7;
                box-shadow: 0 2px 5px rgba(0,0,0,0.05);
                transition: all 0.2s ease;
                background-color: #fff;
                
                &:hover {
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                    transform: translateY(-2px);
                }

                .headline {
                    display: flex;
                    width: 100%;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 8px;
                    
                    .title {
                        font-size: 14px;
                        font-weight: 600;
                        color: #444;
                        text-decoration: none;
                        
                        &:hover {
                            color: #674ea7;
                            text-decoration: underline;
                        }
                    }
                    
                    .time {
                        font-size: 12px;
                        color: #888;
                    }
                }
                
                .description {
                    font-size: 13px;
                    color: #666;
                    margin-bottom: 12px;
                    line-height: 1.4;
                }
                
                .referral-link {
                    margin-top: 12px;
                    text-align: right;
                    
                    a {
                        font-size: 12px;
                        color: #674ea7;
                        text-decoration: none;
                        display: inline-flex;
                        align-items: center;
                        gap: 5px;
                        
                        &:hover {
                            text-decoration: underline;
                        }
                        
                        i {
                            font-size: 10px;
                        }
                    }
                }
                
                .referral-info-wrapper {
                    margin-top: 15px;
                    min-height: 80px;
                    display: block;
                    width: 100%;
                }
                
                .referral-info {
                    background-color: #f8f6ff;
                    border-radius: 6px;
                    padding: 10px;
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    
                    .referral-detail {
                        display: flex;
                        flex-direction: column;
                        padding: 8px;
                        flex: 1; 
                        min-width: 120px;
                        margin-bottom: 5px;
                        
                        .referral-label {
                            font-size: 11px;
                            color: #777;
                            margin-bottom: 6px;
                            font-weight: 500;
                        }
                        
                        .referral-value {
                            font-size: 13px;
                            font-weight: 500;
                            color: #555;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            cursor: default;
                            
                            &.status {
                                padding: 3px 8px;
                                border-radius: 10px;
                                display: inline-block;
                                font-size: 12px;
                                
                                &.active {
                                    background-color: rgba(39, 174, 96, 0.15);
                                    color: #27AE60;
                                }
                                
                                &.paused {
                                    background-color: rgba(241, 196, 15, 0.15);
                                    color: #F39C12;
                                }
                                
                                &.archived {
                                    background-color: rgba(142, 142, 142, 0.15);
                                    color: #7F8C8D;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
